/**
 * @generated SignedSource<<fc59082a9a397e17034d14b97697e132>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PaymentSource = "CASH" | "NONCE" | "RAINCHECK" | "SQUARE_CARD_ON_FILE" | "SQUARE_GIFT_CARD" | "SQUARE_HOUSE_ACCOUNT";
export type AddPaymentRaincheckToBookingInput = {
  bookingId: string;
  raincheckId: string;
};
export type useAddPaymentRaincheckToBookingMutation$variables = {
  input: AddPaymentRaincheckToBookingInput;
  patronLoyalty: boolean;
};
export type useAddPaymentRaincheckToBookingMutation$data = {
  readonly responsePayload: {
    readonly booking: {
      readonly id: string;
      readonly paymentRainchecks?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly projectedCreditApplications?: ReadonlyArray<{
        readonly amount: number;
        readonly paymentSource: PaymentSource;
        readonly raincheck: {
          readonly id: string;
        } | null | undefined;
        readonly squareGiftCard: {
          readonly ganLastFour: string | null | undefined;
          readonly id: string;
        };
      }>;
      readonly totalDueAfterCredits: number | null | undefined;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly success: boolean;
  } | null | undefined;
};
export type useAddPaymentRaincheckToBookingMutation = {
  response: useAddPaymentRaincheckToBookingMutation$data;
  variables: useAddPaymentRaincheckToBookingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "patronLoyalty"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalDueAfterCredits",
  "storageKey": null
},
v8 = [
  (v6/*: any*/)
],
v9 = {
  "condition": "patronLoyalty",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectedCreditApplication",
      "kind": "LinkedField",
      "name": "projectedCreditApplications",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "paymentSource",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SquareGiftCard",
          "kind": "LinkedField",
          "name": "squareGiftCard",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ganLastFour",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Raincheck",
          "kind": "LinkedField",
          "name": "raincheck",
          "plural": false,
          "selections": (v8/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v10 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RaincheckConnection",
    "kind": "LinkedField",
    "name": "paymentRainchecks",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RaincheckEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Raincheck",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v11 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "StandardBooking",
  "abstractKey": null
},
v12 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "LessonBooking",
  "abstractKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAddPaymentRaincheckToBookingMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "AddPaymentRaincheckToBookingPayload",
        "kind": "LinkedField",
        "name": "addPaymentRaincheckToBooking",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "booking",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v9/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAddPaymentRaincheckToBookingMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "AddPaymentRaincheckToBookingPayload",
        "kind": "LinkedField",
        "name": "addPaymentRaincheckToBooking",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "booking",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v9/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3b74f0a82aecda781cdb766e839e5efa",
    "id": null,
    "metadata": {},
    "name": "useAddPaymentRaincheckToBookingMutation",
    "operationKind": "mutation",
    "text": "mutation useAddPaymentRaincheckToBookingMutation(\n  $input: AddPaymentRaincheckToBookingInput!\n  $patronLoyalty: Boolean!\n) {\n  responsePayload: addPaymentRaincheckToBooking(input: $input) {\n    success\n    errors {\n      __typename\n      field\n      code\n      message\n    }\n    booking {\n      __typename\n      id\n      totalDueAfterCredits\n      projectedCreditApplications @include(if: $patronLoyalty) {\n        amount\n        paymentSource\n        squareGiftCard {\n          id\n          ganLastFour\n        }\n        raincheck {\n          id\n        }\n      }\n      ... on StandardBooking {\n        paymentRainchecks {\n          edges {\n            node {\n              id\n            }\n          }\n        }\n      }\n      ... on LessonBooking {\n        paymentRainchecks {\n          edges {\n            node {\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d663e11b9ac4c56b4f283daf49f95278";

export default node;
